import _jsx from "@babel/runtime/helpers/jsx";
var _DisclaimerText;
import React from 'react';
import PropTypes from 'prop-types';
import { StandardPhoneInput } from 'reaxl-forms';
import { DisclaimerText } from 'reaxl';
function TextAlert(_ref) {
  let {
    phone = ''
  } = _ref;
  return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(StandardPhoneInput, {
    id: "phone",
    name: "phone",
    value: phone,
    className: "margin-vertical",
    label: "Phone",
    layout: "inside",
    required: true,
    autoFocus: true
  }), _DisclaimerText || (_DisclaimerText = /*#__PURE__*/_jsx(DisclaimerText, {
    size: 100,
    withContrast: true
  }, void 0, "I consent to receive text alerts at this number from Autotrader for marketing purposes. It\u2019s OK to use an autodialer or artificial/ prerecorded voice. I realize consent is not required to purchase anything, and understand that I can opt-out anytime. Reply STOP to opt-out of texts/SMS. SMS terms, Msg & data rates apply.")));
}
export default TextAlert;